<template>
  <svg :fill="color" viewBox="0 0 28 32" xmlns="http://www.w3.org/2000/svg">
    <path d="M11.14,19c-6.16,0-11.14,4.99-11.14,11.14,0,1.02.83,1.86,1.86,1.86h24.29c1.03,0,1.86-.83,1.86-1.86,0-6.16-4.99-11.14-11.14-11.14h-5.71ZM14,16c2.86,0,5.5-1.52,6.93-4,1.43-2.48,1.43-5.52,0-8-1.43-2.48-4.07-4-6.93-4s-5.5,1.52-6.93,4c-1.43,2.48-1.43,5.52,0,8,1.43,2.48,4.07,4,6.93,4Z"/>
  </svg>
</template>

<script>
export default {
  name: 'IconPerson',
  props: {
    color: {
      type: String,
      default: '#24b9ec'
    }
  }
}
</script>
